import get from 'transmute/get';
export const getCurrentView = get('currentView');